import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationTR from './locales/tr/translation.json';

i18n
  .use(LanguageDetector) // Tarayıcı dili otomatik algılar
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      tr: { translation: translationTR },
    },
    fallbackLng: 'en', // Dil algılanamazsa İngilizce kullanılır
    interpolation: {
      escapeValue: false, // React zaten XSS'e karşı korur
    },
  });

export default i18n;
